export const BACKEND_URL = "https://mydata-backend.primer.gr"
